<template>
  <div class="contents_wrapper">
    <div class='contents'>
      <AboutTableBlock/>

      <h2 class="large_black_label" id="service">創業のきっかけ</h2>
      <AboutSectionBlock/>
    </div>
  </div>
</template>

<script>
  import AboutTableBlock from "@/components/objects/block/about/AboutTableBlock";
  import AboutSectionBlock from "@/components/objects/block/about/AboutSectionBlock";

  export default {
    name: 'About',
    components: {AboutSectionBlock, AboutTableBlock},
  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {
    > .contents {
      @include contents();

      > .about-section_block {
        width: 80%;
      }

      > .large_black_label {
        margin: 8rem 0 2rem 0;
        width: 100%;
      }
    }

    @media screen and (max-width: 767px) {
      > .contents {
        > .about-section_block {
          width: 95%;
        }
      }
    }
  }
</style>